import { FormikHelpers } from "formik";
import { TFunction } from "i18next";
import * as yup from "yup";
import { format } from "date-fns";
import { englishAndCyrillicOnlyRegEx } from "../../../components/Addresses/addressFormHelper";
import { toastResponseError } from "../../../utils/responseMessageHelper";

export interface PassportFormValues {
  serial: string;
  number: string;
  issued_by: string;
  registration: string;
  full_name: string;
  tax_id: string;
  issued_date: Date | null;
  date_of_birth: Date | null;
}

export const passportFormHelper = (
  t: TFunction,
  createPassport: (data: any) => Promise<any>,
  closeRightPanel: () => void,
) => ({
  enableReinitialize: true,
  validateOnChange: true,
  validateOnBlur: false,
  initialValues: {
    serial: "",
    number: "",
    issued_by: "",
    registration: "",
    full_name: "",
    tax_id: "",
    issued_date: null as Date | null,
    date_of_birth: null as Date | null,
  },
  validationSchema: yup.object().shape({
    full_name: yup
      .string()
      .matches(
        englishAndCyrillicOnlyRegEx,
        t("error.englishAndCyrillicOnly"),
      )
      .required(t("error.required", { field: t("books.passports.fullName") })),
    serial: yup
      .string()
      .matches(/^\d+$/, t("error.onlyNumber"))
      .required(t("error.required", { field: t("books.passports.serial") })),
    number: yup
      .string()
      .matches(/^\d+$/, t("error.onlyNumber"))
      .required(t("error.required", { field: t("books.passports.number") })),
    issued_by: yup
      .string()
      .matches(
        englishAndCyrillicOnlyRegEx,
        t("error.englishAndCyrillicOnly"),
      )
      .required(
        t("error.required", { field: t("books.passports.issuedBy") }),
      ),
    registration: yup
      .string()
      .matches(
        englishAndCyrillicOnlyRegEx,
        t("error.englishAndCyrillicOnly"),
      )
      .required(
        t("error.required", { field: t("books.passports.registration") }),
      ),
    tax_id: yup
      .string()
      .matches(/^\d+$/, t("error.onlyNumber"))
      .required(
        t("error.required", { field: t("books.passports.taxId") }),
      ),
    issued_date: yup
      .date()
      .nullable()
      .required(
        t("error.required", { field: t("books.passports.issuedDate") }),
      ),
    date_of_birth: yup
      .date()
      .nullable()
      .required(
        t("error.required", { field: t("books.passports.dateOfBirth") }),
      ),
  }),
  onSubmit: (
    values: PassportFormValues,
    { setSubmitting }: FormikHelpers<PassportFormValues>,
  ) => {
    const formatDate = (date: Date | null) =>
      date ? format(date, "dd.MM.yyyy") : "";

    createPassport({
      passport: {
        serial: values.serial,
        number: values.number,
        issued_by: values.issued_by,
        registration: values.registration,
        full_name: values.full_name,
        tax_id: values.tax_id,
        issued_date: formatDate(values.issued_date),
        date_of_birth: formatDate(values.date_of_birth),
      },
    })
      .then(() => closeRightPanel())
      .catch((response: string) => {
        toastResponseError(response);
      })
      .finally(() => setSubmitting(false));
  },
});
